export default __webpack_public_path__ + "static/media/property_212.fb92e7a1.png";